export const TypeOfCargoList = [
  {
    label: 'Liquid bulk',
    value: 'Liquid bulk',
  },
  {
    label: 'Solid bulk',
    value: 'Solid bulk',
  },
  { label: 'General cargo', value: 'General cargo' },
];

export const StowagePositionList = [
  { label: 'Port', value: 'P' },
  { label: 'Starboard', value: 'S' },
  { label: 'Centre', value: 'C' },
];

export const StowageLevelList = [
  { label: 'Deck', value: 'deck' },
  { label: 'Hold', value: 'hold' },
  { label: 'Tween deck 1', value: 'tweendeck1' },
  { label: 'Tween deck 2', value: 'tweendeck2' },
  { label: 'Tween deck 3', value: 'tweendeck3' },
  { label: 'Tween deck 4', value: 'tweendeck4' },
  { label: 'Tween deck 5', value: 'tweendeck5' },
  { label: 'Tween deck 6', value: 'tweendeck6' },
  { label: 'Tween deck 7', value: 'tweendeck7' },
  { label: 'Tween deck 8', value: 'tweendeck8' },
  { label: 'Tween deck 9', value: 'tweendeck9' },
];

export const TableColumns = [
  {
    header: '',
    disableSortBy: true,
    accessorKey: 'action',
  },
  {
    header: 'Booking or B/L',
    disableSortBy: true,
    accessorKey: 'bookingNumber', // accessorKey is the "key" in the data
  },
  {
    header: 'UN number',
    disableSortBy: true,
    accessorKey: 'un',
  },
  {
    header: 'Proper shipping name',
    disableSortBy: true,
    accessorKey: 'properShippingName',
  },
  {
    header: 'Class',
    disableSortBy: true,
    accessorKey: 'class',
  },
  {
    header: 'Subs. Risk',
    disableSortBy: true,
    accessorKey: 'subsidiaryRisk',
  },
  {
    header: 'Packing group',
    disableSortBy: true,
    accessorKey: 'packingGroup',
  },
  {
    header: 'Flash point (ºC)',
    disableSortBy: true,
    accessorKey: 'flashPoint',
  },
  {
    header: 'EmS',
    disableSortBy: true,
    accessorKey: 'ems',
  },
  {
    header: 'Stowage Position',
    disableSortBy: true,
    accessorKey: 'stowagePosition',
  },
  {
    header: 'Reference number',
    disableSortBy: true,
    accessorKey: 'referenceNumber',
  },
  {
    header: 'Marks & Numbers',
    disableSortBy: true,
    accessorKey: 'marksAndNumbers',
  },
  {
    header: 'Number/kind of packages',
    disableSortBy: true,
    accessorKey: 'numberOfPackages',
  },
  {
    header: 'Mass (kg) or Volume (m3)',
    disableSortBy: true,
    accessorKey: 'massOrVolume',
  },
  {
    header: 'Loading Port',
    disableSortBy: true,
    accessorKey: 'loadPort',
  },
  {
    header: 'Discharge port',
    disableSortBy: true,
    accessorKey: 'dischargePort',
  },
];

export const initialFormDangerousGoodsValues = {
  grossMass: null,
  netVolume: null,
  typeOfCargo: null,
  tankHoldNumber: null,
  netWeight: null,
  dischargePort: null,
  loadPort: null,
  receiverName: null,
  receiverCountry: null,
  receiverCity: null,
  receiverAddress: null,
  receiverVatNumber: null,
  receiverPhoneNumber: null,
  shipperName: null,
  shipperCountry: null,
  shipperCity: null,
  shipperAddress: null,
  shipperVatNumber: null,
  shipperPhoneNumber: null,
  un: null,
  name: null,
  class: null,
  packingGroup: null,
  classificationCode: null,
  ec: null,
  cas: null,
  ems: null,
  labels: null,
  properShippingName: null,
  cargoOperations: null,
  subsidiaryRisk: null,
  stowagePosition: null,
  flashPoint: null,
  referenceNumber: null,
  marksAndNumbers: null,
  massOrVolume: null,
  shipper: null,
  consignee: null,
  marinePollutant: false,
  specialProvisions: null,
  typeOfUnit: null,
  numberOfPackages: null,
  containerGroup: null,
};
